import __var_0__ from '@stdlib/buffer/ctor';
import __var_1__ from '@stdlib/array/float64';
import __var_2__ from '@stdlib/array/float32';
import __var_3__ from '@stdlib/array/int16';
import __var_4__ from '@stdlib/array/int32';
import __var_5__ from '@stdlib/array/int8';
import __var_6__ from '@stdlib/array/uint16';
import __var_7__ from '@stdlib/array/uint32';
import __var_8__ from '@stdlib/array/uint8';
import __var_9__ from '@stdlib/array/uint8c';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var Buffer = __var_0__;
var Float64Array = __var_1__;
var Float32Array = __var_2__;
var Int16Array = __var_3__;
var Int32Array = __var_4__;
var Int8Array = __var_5__;
var Uint16Array = __var_6__;
var Uint32Array = __var_7__;
var Uint8Array = __var_8__;
var Uint8ClampedArray = __var_9__;


// MAIN //

// Mapping from data types to underlying buffer constructors...
var ctors = {
	'binary': Buffer,
	'float64': Float64Array,
	'float32': Float32Array,
	'generic': Array, // TODO: replace with `stdlib` pkg
	'int16': Int16Array,
	'int32': Int32Array,
	'int8': Int8Array,
	'uint16': Uint16Array,
	'uint32': Uint32Array,
	'uint8': Uint8Array,
	'uint8c': Uint8ClampedArray
};


// EXPORTS //
export default ctors;
